import { ShelterCta } from "./shelter-cta";
import {
    MobileFloatingAction,
    FLOATING_ACTION_CLASS,
} from "@wags/ui/mobile-floating-action.tsx";

export function ShelterMobileAction({
    applicationUrl,
    isApplicationPage,
    organizationName,
    onContact,
}: {
    applicationUrl: string | null;
    isApplicationPage?: boolean;
    organizationName: string;
    onContact?: () => void;
}) {
    if (!applicationUrl && !onContact) return null;
    return (
        <MobileFloatingAction style={{ WebkitTouchCallout: "none" }}>
            <ShelterCta
                applicationUrl={applicationUrl}
                isApplicationPage={isApplicationPage}
                organizationName={organizationName}
                onContact={onContact}
                className={FLOATING_ACTION_CLASS}
            />
        </MobileFloatingAction>
    );
}
